type SpecialtyCode = {
  classification: string;
  specialization: string;
};

/**
 * NUCC Provider Taxonomy Code mappings for medical specialties
 * Reference: https://nucc.org/index.php/code-sets-mainmenu-41/provider-taxonomy-mainmenu-40/csv-mainmenu-57
 */
export const PRACTITIONER_SPECIALTY_CODES: Record<string, SpecialtyCode> = {
  "193200000X": { classification: "Multi-Specialty", specialization: "" },
  "193400000X": { classification: "Single Specialty", specialization: "" },
  "207K00000X": { classification: "Allergy & Immunology", specialization: "" },
  "207KA0200X": { classification: "Allergy & Immunology", specialization: "Allergy" },
  "207KI0005X": {
    classification: "Allergy & Immunology",
    specialization: "Clinical & Laboratory Immunology",
  },
  "207L00000X": { classification: "Anesthesiology", specialization: "" },
  "207LA0401X": { classification: "Anesthesiology", specialization: "Addiction Medicine" },
  "207LC0200X": { classification: "Anesthesiology", specialization: "Critical Care Medicine" },
  "207LH0002X": {
    classification: "Anesthesiology",
    specialization: "Hospice and Palliative Medicine",
  },
  "207LP2900X": { classification: "Anesthesiology", specialization: "Pain Medicine" },
  "207LP3000X": { classification: "Anesthesiology", specialization: "Pediatric Anesthesiology" },
  "207LP4000X": {
    classification: "Anesthesiology",
    specialization: "Physician Nutrition Specialist",
  },
  "208U00000X": { classification: "Clinical Pharmacology", specialization: "" },
  "208C00000X": { classification: "Colon & Rectal Surgery", specialization: "" },
  "207N00000X": { classification: "Dermatology", specialization: "" },
  "207NI0002X": {
    classification: "Dermatology",
    specialization: "Clinical & Laboratory Dermatological Immunology",
  },
  "207ND0900X": { classification: "Dermatology", specialization: "Dermatopathology" },
  "207ND0101X": { classification: "Dermatology", specialization: "MOHS-Micrographic Surgery" },
  "207NP0225X": { classification: "Dermatology", specialization: "Pediatric Dermatology" },
  "207NS0135X": { classification: "Dermatology", specialization: "Procedural Dermatology" },
  "204R00000X": { classification: "Electrodiagnostic Medicine", specialization: "" },
  "207P00000X": { classification: "Emergency Medicine", specialization: "" },
  "207PE0004X": {
    classification: "Emergency Medicine",
    specialization: "Emergency Medical Services",
  },
  "207PH0002X": {
    classification: "Emergency Medicine",
    specialization: "Hospice and Palliative Medicine",
  },
  "207PT0002X": { classification: "Emergency Medicine", specialization: "Medical Toxicology" },
  "207PP0204X": {
    classification: "Emergency Medicine",
    specialization: "Pediatric Emergency Medicine",
  },
  "207PS0010X": { classification: "Emergency Medicine", specialization: "Sports Medicine" },
  "207PE0005X": {
    classification: "Emergency Medicine",
    specialization: "Undersea and Hyperbaric Medicine",
  },
  "207Q00000X": { classification: "Family Medicine", specialization: "" },
  "207QA0401X": { classification: "Family Medicine", specialization: "Addiction Medicine" },
  "207QA0000X": { classification: "Family Medicine", specialization: "Adolescent Medicine" },
  "207QA0505X": { classification: "Family Medicine", specialization: "Adult Medicine" },
  "207QD0401X": { classification: "Family Medicine", specialization: "Diabetology" },
  "207QG0300X": { classification: "Family Medicine", specialization: "Geriatric Medicine" },
  "207QH0002X": {
    classification: "Family Medicine",
    specialization: "Hospice and Palliative Medicine",
  },
  "207QB0002X": { classification: "Family Medicine", specialization: "Obesity Medicine" },
  "207QP0002X": {
    classification: "Family Medicine",
    specialization: "Physician Nutrition Specialist",
  },
  "207QS1201X": { classification: "Family Medicine", specialization: "Sleep Medicine" },
  "207QS0010X": { classification: "Family Medicine", specialization: "Sports Medicine" },
  "208D00000X": { classification: "General Practice", specialization: "" },
  "208M00000X": { classification: "Hospitalist", specialization: "" },
  "202C00000X": { classification: "Independent Medical Examiner", specialization: "" },
  "202D00000X": { classification: "Integrative Medicine", specialization: "" },
  "207R00000X": { classification: "Internal Medicine", specialization: "" },
  "207RA0401X": { classification: "Internal Medicine", specialization: "Addiction Medicine" },
  "207RA0000X": { classification: "Internal Medicine", specialization: "Adolescent Medicine" },
  "207RA0002X": {
    classification: "Internal Medicine",
    specialization: "Adult Congenital Heart Disease",
  },
  "207RA0001X": {
    classification: "Internal Medicine",
    specialization: "Advanced Heart Failure and Transplant Cardiology",
  },
  "207RA0201X": { classification: "Internal Medicine", specialization: "Allergy & Immunology" },
  "207RC0000X": { classification: "Internal Medicine", specialization: "Cardiovascular Disease" },
  "207RI0001X": {
    classification: "Internal Medicine",
    specialization: "Clinical & Laboratory Immunology",
  },
  "207RC0001X": {
    classification: "Internal Medicine",
    specialization: "Clinical Cardiac Electrophysiology",
  },
  "207RC0200X": { classification: "Internal Medicine", specialization: "Critical Care Medicine" },
  "207QB0505X": { classification: "Internal Medicine", specialization: "Diabetology" },
  "207RE0101X": {
    classification: "Internal Medicine",
    specialization: "Endocrinology, Diabetes & Metabolism",
  },
  "207RG0100X": { classification: "Internal Medicine", specialization: "Gastroenterology" },
  "207RG0300X": { classification: "Internal Medicine", specialization: "Geriatric Medicine" },
  "207RH0000X": { classification: "Internal Medicine", specialization: "Hematology" },
  "207RH0003X": { classification: "Internal Medicine", specialization: "Hematology & Oncology" },
  "207RI0008X": { classification: "Internal Medicine", specialization: "Hepatology" },
  "207RH0002X": {
    classification: "Internal Medicine",
    specialization: "Hospice and Palliative Medicine",
  },
  "207RH0005X": { classification: "Internal Medicine", specialization: "Hypertension Specialist" },
  "207RI0200X": { classification: "Internal Medicine", specialization: "Infectious Disease" },
  "207RI0011X": {
    classification: "Internal Medicine",
    specialization: "Interventional Cardiology",
  },
  "207RM1200X": {
    classification: "Internal Medicine",
    specialization: "Magnetic Resonance Imaging (MRI)",
  },
  "207RX0202X": { classification: "Internal Medicine", specialization: "Medical Oncology" },
  "207RN0300X": { classification: "Internal Medicine", specialization: "Nephrology" },
  "207RB0002X": { classification: "Internal Medicine", specialization: "Obesity Medicine" },
  "207RP1002X": {
    classification: "Internal Medicine",
    specialization: "Physician Nutrition Specialist",
  },
  "207RP1001X": { classification: "Internal Medicine", specialization: "Pulmonary Disease" },
  "207RR0500X": { classification: "Internal Medicine", specialization: "Rheumatology" },
  "207RS0012X": { classification: "Internal Medicine", specialization: "Sleep Medicine" },
  "207RS0010X": { classification: "Internal Medicine", specialization: "Sports Medicine" },
  "207RT0003X": { classification: "Internal Medicine", specialization: "Transplant Hepatology" },
  "209800000X": { classification: "Legal Medicine", specialization: "" },
  "207SG0202X": {
    classification: "Medical Genetics",
    specialization: "Clinical Biochemical Genetics",
  },
  "207SC0300X": { classification: "Medical Genetics", specialization: "Clinical Cytogenetics" },
  "207SG0201X": { classification: "Medical Genetics", specialization: "Clinical Genetics (M.D.)" },
  "207SG0203X": {
    classification: "Medical Genetics",
    specialization: "Clinical Molecular Genetics",
  },
  "207SG0207X": {
    classification: "Medical Genetics",
    specialization: "Medical Biochemical Genetics",
  },
  "207SM0001X": {
    classification: "Medical Genetics",
    specialization: "Molecular Genetic Pathology",
  },
  "207SG0205X": { classification: "Medical Genetics", specialization: "Ph.D. Medical Genetics" },
  "207T00000X": { classification: "Neurological Surgery", specialization: "" },
  "204D00000X": { classification: "Neuromusculoskeletal Medicine & OMM", specialization: "" },
  "204C00000X": {
    classification: "Neuromusculoskeletal Medicine, Sports Medicine",
    specialization: "",
  },
  "207U00000X": { classification: "Nuclear Medicine", specialization: "" },
  "207UN0903X": {
    classification: "Nuclear Medicine",
    specialization: "In Vivo & In Vitro Nuclear Medicine",
  },
  "207UN0901X": { classification: "Nuclear Medicine", specialization: "Nuclear Cardiology" },
  "207UN0902X": { classification: "Nuclear Medicine", specialization: "Nuclear Imaging & Therapy" },
  "207V00000X": { classification: "Obstetrics & Gynecology", specialization: "" },
  "207VC0300X": {
    classification: "Obstetrics & Gynecology",
    specialization: "Complex Family Planning",
  },
  "207VC0200X": {
    classification: "Obstetrics & Gynecology",
    specialization: "Critical Care Medicine",
  },
  "207VF0040X": {
    classification: "Obstetrics & Gynecology",
    specialization: "Urogynecology and Reconstructive Pelvic Surgery",
  },
  "207VX0201X": {
    classification: "Obstetrics & Gynecology",
    specialization: "Gynecologic Oncology",
  },
  "207VG0400X": { classification: "Obstetrics & Gynecology", specialization: "Gynecology" },
  "207VH0002X": {
    classification: "Obstetrics & Gynecology",
    specialization: "Hospice and Palliative Medicine",
  },
  "207VM0101X": {
    classification: "Obstetrics & Gynecology",
    specialization: "Maternal & Fetal Medicine",
  },
  "207VB0002X": { classification: "Obstetrics & Gynecology", specialization: "Obesity Medicine" },
  "207VX0000X": { classification: "Obstetrics & Gynecology", specialization: "Obstetrics" },
  "207VE0102X": {
    classification: "Obstetrics & Gynecology",
    specialization: "Reproductive Endocrinology",
  },
  "207W00000X": { classification: "Ophthalmology", specialization: "" },
  "207WX0120X": {
    classification: "Ophthalmology",
    specialization: "Cornea and External Diseases Specialist",
  },
  "207WX0009X": { classification: "Ophthalmology", specialization: "Glaucoma Specialist" },
  "207WX0109X": { classification: "Ophthalmology", specialization: "Neuro-ophthalmology" },
  "207WX0200X": {
    classification: "Ophthalmology",
    specialization: "Ophthalmic Plastic and Reconstructive Surgery",
  },
  "207WX0110X": {
    classification: "Ophthalmology",
    specialization: "Pediatric Ophthalmology and Strabismus Specialist",
  },
  "207WX0107X": { classification: "Ophthalmology", specialization: "Retina Specialist" },
  "207WX0108X": {
    classification: "Ophthalmology",
    specialization: "Uveitis and Ocular Inflammatory Disease",
  },
  "204E00000X": { classification: "Oral & Maxillofacial Surgery", specialization: "" },
  "207X00000X": { classification: "Orthopaedic Surgery", specialization: "" },
  "207XS0114X": {
    classification: "Orthopaedic Surgery",
    specialization: "Adult Reconstructive Orthopaedic Surgery",
  },
  "207XX0004X": { classification: "Orthopaedic Surgery", specialization: "Foot and Ankle Surgery" },
  "207XS0106X": { classification: "Orthopaedic Surgery", specialization: "Hand Surgery" },
  "207XS0117X": {
    classification: "Orthopaedic Surgery",
    specialization: "Orthopaedic Surgery of the Spine",
  },
  "207XX0801X": { classification: "Orthopaedic Surgery", specialization: "Orthopaedic Trauma" },
  "207XP3100X": {
    classification: "Orthopaedic Surgery",
    specialization: "Pediatric Orthopaedic Surgery",
  },
  "207XX0005X": { classification: "Orthopaedic Surgery", specialization: "Sports Medicine" },
  "207Y00000X": { classification: "Otolaryngology", specialization: "" },
  "207YS0123X": { classification: "Otolaryngology", specialization: "Facial Plastic Surgery" },
  "207YX0602X": { classification: "Otolaryngology", specialization: "Otolaryngic Allergy" },
  "207YX0905X": {
    classification: "Otolaryngology",
    specialization: "Otolaryngology/Facial Plastic Surgery",
  },
  "207YX0901X": { classification: "Otolaryngology", specialization: "Otology & Neurotology" },
  "207YP0228X": { classification: "Otolaryngology", specialization: "Pediatric Otolaryngology" },
  "207YX0007X": {
    classification: "Otolaryngology",
    specialization: "Plastic Surgery within the Head & Neck",
  },
  "207YS0012X": { classification: "Otolaryngology", specialization: "Sleep Medicine" },
  "208VP0014X": { classification: "Pain Medicine", specialization: "Interventional Pain Medicine" },
  "208VP0000X": { classification: "Pain Medicine", specialization: "Pain Medicine" },
  "207ZP0101X": { classification: "Pathology", specialization: "Anatomic Pathology" },
  "207ZP0102X": {
    classification: "Pathology",
    specialization: "Anatomic Pathology & Clinical Pathology",
  },
  "207ZB0001X": {
    classification: "Pathology",
    specialization: "Blood Banking & Transfusion Medicine",
  },
  "207ZP0104X": { classification: "Pathology", specialization: "Chemical Pathology" },
  "207ZC0008X": { classification: "Pathology", specialization: "Clinical Informatics" },
  "207ZC0006X": { classification: "Pathology", specialization: "Clinical Pathology" },
  "207ZP0105X": {
    classification: "Pathology",
    specialization: "Clinical Pathology/Laboratory Medicine",
  },
  "207ZC0500X": { classification: "Pathology", specialization: "Cytopathology" },
  "207ZD0900X": { classification: "Pathology", specialization: "Dermatopathology" },
  "207ZF0201X": { classification: "Pathology", specialization: "Forensic Pathology" },
  "207ZH0000X": { classification: "Pathology", specialization: "Hematology" },
  "207ZI0100X": { classification: "Pathology", specialization: "Immunopathology" },
  "207ZM0300X": { classification: "Pathology", specialization: "Medical Microbiology" },
  "207ZP0007X": { classification: "Pathology", specialization: "Molecular Genetic Pathology" },
  "207ZN0500X": { classification: "Pathology", specialization: "Neuropathology" },
  "207ZP0213X": { classification: "Pathology", specialization: "Pediatric Pathology" },
  "208000000X": { classification: "Pediatrics", specialization: "" },
  "2080A0000X": { classification: "Pediatrics", specialization: "Adolescent Medicine" },
  "2080C0008X": { classification: "Pediatrics", specialization: "Child Abuse Pediatrics" },
  "2080I0007X": {
    classification: "Pediatrics",
    specialization: "Clinical & Laboratory Immunology",
  },
  "2080P0006X": {
    classification: "Pediatrics",
    specialization: "Developmental - Behavioral Pediatrics",
  },
  "2080H0002X": { classification: "Pediatrics", specialization: "Hospice and Palliative Medicine" },
  "2080T0002X": { classification: "Pediatrics", specialization: "Medical Toxicology" },
  "2080N0001X": { classification: "Pediatrics", specialization: "Neonatal-Perinatal Medicine" },
  "2080P0008X": { classification: "Pediatrics", specialization: "Neurodevelopmental Disabilities" },
  "2080B0002X": { classification: "Pediatrics", specialization: "Obesity Medicine" },
  "2080P0201X": { classification: "Pediatrics", specialization: "Pediatric Allergy/Immunology" },
  "2080P0202X": { classification: "Pediatrics", specialization: "Pediatric Cardiology" },
  "2080P0203X": {
    classification: "Pediatrics",
    specialization: "Pediatric Critical Care Medicine",
  },
  "2080P0204X": { classification: "Pediatrics", specialization: "Pediatric Emergency Medicine" },
  "2080P0205X": { classification: "Pediatrics", specialization: "Pediatric Endocrinology" },
  "2080P0206X": { classification: "Pediatrics", specialization: "Pediatric Gastroenterology" },
  "2080P0207X": { classification: "Pediatrics", specialization: "Pediatric Hematology-Oncology" },
  "2080P0208X": { classification: "Pediatrics", specialization: "Pediatric Infectious Diseases" },
  "2080P0210X": { classification: "Pediatrics", specialization: "Pediatric Nephrology" },
  "2080P0214X": { classification: "Pediatrics", specialization: "Pediatric Pulmonology" },
  "2080P0216X": { classification: "Pediatrics", specialization: "Pediatric Rheumatology" },
  "2080T0004X": { classification: "Pediatrics", specialization: "Pediatric Transplant Hepatology" },
  "2080P1004X": { classification: "Pediatrics", specialization: "Physician Nutrition Specialist" },
  "2080S0012X": { classification: "Pediatrics", specialization: "Sleep Medicine" },
  "2080S0010X": { classification: "Pediatrics", specialization: "Sports Medicine" },
  "202K00000X": { classification: "Phlebology", specialization: "" },
  "208100000X": { classification: "Physical Medicine & Rehabilitation", specialization: "" },
  "2081P0301X": {
    classification: "Physical Medicine & Rehabilitation",
    specialization: "Brain Injury Medicine",
  },
  "2081H0002X": {
    classification: "Physical Medicine & Rehabilitation",
    specialization: "Hospice and Palliative Medicine",
  },
  "2081N0008X": {
    classification: "Physical Medicine & Rehabilitation",
    specialization: "Neuromuscular Medicine",
  },
  "2081P2900X": {
    classification: "Physical Medicine & Rehabilitation",
    specialization: "Pain Medicine",
  },
  "2081P0010X": {
    classification: "Physical Medicine & Rehabilitation",
    specialization: "Pediatric Rehabilitation Medicine",
  },
  "2081P0004X": {
    classification: "Physical Medicine & Rehabilitation",
    specialization: "Spinal Cord Injury Medicine",
  },
  "2081S0010X": {
    classification: "Physical Medicine & Rehabilitation",
    specialization: "Sports Medicine",
  },
  "208200000X": { classification: "Plastic Surgery", specialization: "" },
  "2082S0099X": {
    classification: "Plastic Surgery",
    specialization: "Plastic Surgery Within the Head and Neck",
  },
  "2082S0105X": { classification: "Plastic Surgery", specialization: "Surgery of the Hand" },
  "2083A0300X": { classification: "Preventive Medicine", specialization: "Addiction Medicine" },
  "2083A0100X": { classification: "Preventive Medicine", specialization: "Aerospace Medicine" },
  "2083C0008X": { classification: "Preventive Medicine", specialization: "Clinical Informatics" },
  "2083T0002X": { classification: "Preventive Medicine", specialization: "Medical Toxicology" },
  "2083B0002X": { classification: "Preventive Medicine", specialization: "Obesity Medicine" },
  "2083X0100X": { classification: "Preventive Medicine", specialization: "Occupational Medicine" },
  "2083P0500X": {
    classification: "Preventive Medicine",
    specialization: "Preventive Medicine/Occupational Environmental Medicine",
  },
  "2083P0901X": {
    classification: "Preventive Medicine",
    specialization: "Public Health & General Preventive Medicine",
  },
  "2083S0010X": { classification: "Preventive Medicine", specialization: "Sports Medicine" },
  "2083P0011X": {
    classification: "Preventive Medicine",
    specialization: "Undersea and Hyperbaric Medicine",
  },
  "2084A0401X": { classification: "Psychiatry & Neurology", specialization: "Addiction Medicine" },
  "2084P0802X": {
    classification: "Psychiatry & Neurology",
    specialization: "Addiction Psychiatry",
  },
  "2084B0040X": {
    classification: "Psychiatry & Neurology",
    specialization: "Behavioral Neurology & Neuropsychiatry",
  },
  "2084P0301X": {
    classification: "Psychiatry & Neurology",
    specialization: "Brain Injury Medicine",
  },
  "2084P0804X": {
    classification: "Psychiatry & Neurology",
    specialization: "Child & Adolescent Psychiatry",
  },
  "2084N0600X": {
    classification: "Psychiatry & Neurology",
    specialization: "Clinical Neurophysiology",
  },
  "2084D0003X": {
    classification: "Psychiatry & Neurology",
    specialization: "Diagnostic Neuroimaging",
  },
  "2084E0001X": { classification: "Psychiatry & Neurology", specialization: "Epilepsy" },
  "2084F0202X": { classification: "Psychiatry & Neurology", specialization: "Forensic Psychiatry" },
  "2084P0805X": {
    classification: "Psychiatry & Neurology",
    specialization: "Geriatric Psychiatry",
  },
  "2084H0002X": {
    classification: "Psychiatry & Neurology",
    specialization: "Hospice and Palliative Medicine",
  },
  "2084A2900X": { classification: "Psychiatry & Neurology", specialization: "Neurocritical Care" },
  "2084P0005X": {
    classification: "Psychiatry & Neurology",
    specialization: "Neurodevelopmental Disabilities",
  },
  "2084N0400X": { classification: "Psychiatry & Neurology", specialization: "Neurology" },
  "2084N0402X": {
    classification: "Psychiatry & Neurology",
    specialization: "Neurology with Special Qualifications in Child Neurology",
  },
  "2084N0008X": {
    classification: "Psychiatry & Neurology",
    specialization: "Neuromuscular Medicine",
  },
  "2084B0002X": { classification: "Psychiatry & Neurology", specialization: "Obesity Medicine" },
  "2084P2900X": { classification: "Psychiatry & Neurology", specialization: "Pain Medicine" },
  "2084P0800X": { classification: "Psychiatry & Neurology", specialization: "Psychiatry" },
  "2084P0015X": {
    classification: "Psychiatry & Neurology",
    specialization: "Psychosomatic Medicine",
  },
  "2084S0012X": { classification: "Psychiatry & Neurology", specialization: "Sleep Medicine" },
  "2084S0010X": { classification: "Psychiatry & Neurology", specialization: "Sports Medicine" },
  "2084V0102X": { classification: "Psychiatry & Neurology", specialization: "Vascular Neurology" },
  "2085B0100X": { classification: "Radiology", specialization: "Body Imaging" },
  "2085D0003X": { classification: "Radiology", specialization: "Diagnostic Neuroimaging" },
  "2085R0202X": { classification: "Radiology", specialization: "Diagnostic Radiology" },
  "2085U0001X": { classification: "Radiology", specialization: "Diagnostic Ultrasound" },
  "2085H0002X": { classification: "Radiology", specialization: "Hospice and Palliative Medicine" },
  "2085N0700X": { classification: "Radiology", specialization: "Neuroradiology" },
  "2085N0904X": { classification: "Radiology", specialization: "Nuclear Radiology" },
  "2085P0229X": { classification: "Radiology", specialization: "Pediatric Radiology" },
  "2085R0001X": { classification: "Radiology", specialization: "Radiation Oncology" },
  "2085R0205X": { classification: "Radiology", specialization: "Radiological Physics" },
  "2085R0203X": { classification: "Radiology", specialization: "Therapeutic Radiology" },
  "2085R0204X": {
    classification: "Radiology",
    specialization: "Vascular & Interventional Radiology",
  },
  "208600000X": { classification: "Surgery", specialization: "" },
  "2086H0002X": { classification: "Surgery", specialization: "Hospice and Palliative Medicine" },
  "2086S0120X": { classification: "Surgery", specialization: "Pediatric Surgery" },
  "2086P0122X": { classification: "Surgery", specialization: "Physician Nutrition Specialist" },
  "2086S0122X": { classification: "Surgery", specialization: "Plastic and Reconstructive Surgery" },
  "2086S0105X": { classification: "Surgery", specialization: "Surgery of the Hand" },
  "2086S0102X": { classification: "Surgery", specialization: "Surgical Critical Care" },
  "2086X0206X": { classification: "Surgery", specialization: "Surgical Oncology" },
  "2086S0127X": { classification: "Surgery", specialization: "Trauma Surgery" },
  "2086S0129X": { classification: "Surgery", specialization: "Vascular Surgery" },
  "208G00000X": {
    classification: "Thoracic Surgery (Cardiothoracic Vascular Surgery)",
    specialization: "",
  },
  "204F00000X": { classification: "Transplant Surgery", specialization: "" },
  "208800000X": { classification: "Urology", specialization: "" },
  "2088F0040X": {
    classification: "Urology",
    specialization: "Urogynecology and Reconstructive Pelvic Surgery",
  },
  "2088P0231X": { classification: "Urology", specialization: "Pediatric Urology" },
  "106E00000X": { classification: "Assistant Behavior Analyst", specialization: "" },
  "106S00000X": { classification: "Behavior Technician", specialization: "" },
  "103K00000X": { classification: "Behavior Analyst", specialization: "" },
  "103G00000X": { classification: "Clinical Neuropsychologist", specialization: "" },
  "103GC0700X": { classification: "Clinical Neuropsychologist", specialization: "Clinical" },
  "101Y00000X": { classification: "Counselor", specialization: "" },
  "101YA0400X": {
    classification: "Counselor",
    specialization: "Addiction (Substance Use Disorder)",
  },
  "101YM0800X": { classification: "Counselor", specialization: "Mental Health" },
  "101YP1600X": { classification: "Counselor", specialization: "Pastoral" },
  "101YP2500X": { classification: "Counselor", specialization: "Professional" },
  "101YS0200X": { classification: "Counselor", specialization: "School" },
  "101200000X": { classification: "Drama Therapist", specialization: "" },
  "106H00000X": { classification: "Marriage & Family Therapist", specialization: "" },
  "102X00000X": { classification: "Poetry Therapist", specialization: "" },
  "102L00000X": { classification: "Psychoanalyst", specialization: "" },
  "103T00000X": { classification: "Psychologist", specialization: "" },
  "103TA0400X": {
    classification: "Psychologist",
    specialization: "Addiction (Substance Use Disorder)",
  },
  "103TA0700X": { classification: "Psychologist", specialization: "Adult Development & Aging" },
  "103TC0700X": { classification: "Psychologist", specialization: "Clinical" },
  "103TC2200X": { classification: "Psychologist", specialization: "Clinical Child & Adolescent" },
  "103TB0200X": { classification: "Psychologist", specialization: "Cognitive & Behavioral" },
  "103TC1900X": { classification: "Psychologist", specialization: "Counseling" },
  "103TE1000X": { classification: "Psychologist", specialization: "Educational" },
  "103TE1100X": { classification: "Psychologist", specialization: "Exercise & Sports" },
  "103TF0000X": { classification: "Psychologist", specialization: "Family" },
  "103TF0200X": { classification: "Psychologist", specialization: "Forensic" },
  "103TP2701X": { classification: "Psychologist", specialization: "Group Psychotherapy" },
  "103TH0004X": { classification: "Psychologist", specialization: "Health" },
  "103TH0100X": { classification: "Psychologist", specialization: "Health Service" },
  "103TM1700X": { classification: "Psychologist", specialization: "Men & Masculinity" },
  "103TM1800X": {
    classification: "Psychologist",
    specialization: "Intellectual & Developmental Disabilities",
  },
  "103TP0016X": { classification: "Psychologist", specialization: "Prescribing (Medical)" },
  "103TP0814X": { classification: "Psychologist", specialization: "Psychoanalysis" },
  "103TP2700X": { classification: "Psychologist", specialization: "Psychotherapy" },
  "103TR0400X": { classification: "Psychologist", specialization: "Rehabilitation" },
  "103TS0200X": { classification: "Psychologist", specialization: "School" },
  "103TW0100X": { classification: "Psychologist", specialization: "Women" },
  "104100000X": { classification: "Social Worker", specialization: "" },
  "1041C0700X": { classification: "Social Worker", specialization: "Clinical" },
  "1041S0200X": { classification: "Social Worker", specialization: "School" },
  "111N00000X": { classification: "Chiropractor", specialization: "" },
  "111NI0013X": { classification: "Chiropractor", specialization: "Independent Medical Examiner" },
  "111NI0900X": { classification: "Chiropractor", specialization: "Internist" },
  "111NN0400X": { classification: "Chiropractor", specialization: "Neurology" },
  "111NN1001X": { classification: "Chiropractor", specialization: "Nutrition" },
  "111NX0100X": { classification: "Chiropractor", specialization: "Occupational Health" },
  "111NX0800X": { classification: "Chiropractor", specialization: "Orthopedic" },
  "111NP0017X": { classification: "Chiropractor", specialization: "Pediatric Chiropractor" },
  "111NR0200X": { classification: "Chiropractor", specialization: "Radiology" },
  "111NR0400X": { classification: "Chiropractor", specialization: "Rehabilitation" },
  "111NS0005X": { classification: "Chiropractor", specialization: "Sports Physician" },
  "111NT0100X": { classification: "Chiropractor", specialization: "Thermography" },
  "125K00000X": { classification: "Advanced Practice Dental Therapist", specialization: "" },
  "126800000X": { classification: "Dental Assistant", specialization: "" },
  "124Q00000X": { classification: "Dental Hygienist", specialization: "" },
  "126900000X": { classification: "Dental Laboratory Technician", specialization: "" },
  "125J00000X": { classification: "Dental Therapist", specialization: "" },
  "122300000X": { classification: "Dentist", specialization: "" },
  "1223D0004X": { classification: "Dentist", specialization: "Dental Anesthesiology" },
  "1223D0001X": { classification: "Dentist", specialization: "Dental Public Health" },
  "1223E0200X": { classification: "Dentist", specialization: "Endodontics" },
  "1223G0001X": { classification: "Dentist", specialization: "General Practice" },
  "1223P0106X": { classification: "Dentist", specialization: "Oral and Maxillofacial Pathology" },
  "1223X0008X": { classification: "Dentist", specialization: "Oral and Maxillofacial Radiology" },
  "1223S0112X": { classification: "Dentist", specialization: "Oral and Maxillofacial Surgery" },
  "125Q00000X": { classification: "Dentist", specialization: "Oral Medicine" },
  "1223X2210X": { classification: "Dentist", specialization: "Orofacial Pain" },
  "1223X0400X": {
    classification: "Dentist",
    specialization: "Orthodontics and Dentofacial Orthopedics",
  },
  "1223P0221X": { classification: "Dentist", specialization: "Pediatric Dentistry" },
  "1223P0300X": { classification: "Dentist", specialization: "Periodontics" },
  "1223P0700X": { classification: "Dentist", specialization: "Prosthodontics" },
  "122400000X": { classification: "Denturist", specialization: "" },
  "132700000X": { classification: "Dietary Manager", specialization: "" },
  "136A00000X": { classification: "Dietetic Technician, Registered", specialization: "" },
  "133V00000X": { classification: "Dietitian, Registered", specialization: "" },
  "133VN1101X": {
    classification: "Dietitian, Registered",
    specialization: "Nutrition, Gerontological",
  },
  "133VN1006X": { classification: "Dietitian, Registered", specialization: "Nutrition, Metabolic" },
  "133VN1201X": {
    classification: "Dietitian, Registered",
    specialization: "Nutrition, Obesity and Weight Management",
  },
  "133VN1301X": { classification: "Dietitian, Registered", specialization: "Nutrition, Oncology" },
  "133VN1004X": { classification: "Dietitian, Registered", specialization: "Nutrition, Pediatric" },
  "133VN1401X": {
    classification: "Dietitian, Registered",
    specialization: "Nutrition, Pediatric Critical Care",
  },
  "133VN1005X": { classification: "Dietitian, Registered", specialization: "Nutrition, Renal" },
  "133VN1501X": {
    classification: "Dietitian, Registered",
    specialization: "Nutrition, Sports Dietetics",
  },
  "133N00000X": { classification: "Nutritionist", specialization: "" },
  "133NN1002X": { classification: "Nutritionist", specialization: "Nutrition, Education" },
  "146E00000X": { classification: "Community Paramedic", specialization: "" },
  "146N00000X": { classification: "Emergency Medical Technician, Basic", specialization: "" },
  "146M00000X": {
    classification: "Emergency Medical Technician, Intermediate",
    specialization: "",
  },
  "146L00000X": { classification: "Emergency Medical Technician, Paramedic", specialization: "" },
  "146D00000X": { classification: "Personal Emergency Response Attendant", specialization: "" },
  "152W00000X": { classification: "Optometrist", specialization: "" },
  "152WC0802X": { classification: "Optometrist", specialization: "Corneal and Contact Management" },
  "152WL0500X": { classification: "Optometrist", specialization: "Low Vision Rehabilitation" },
  "152WX0102X": { classification: "Optometrist", specialization: "Occupational Vision" },
  "152WP0200X": { classification: "Optometrist", specialization: "Pediatrics" },
  "152WS0006X": { classification: "Optometrist", specialization: "Sports Vision" },
  "152WV0400X": { classification: "Optometrist", specialization: "Vision Therapy" },
  "156F00000X": { classification: "Technician/Technologist", specialization: "" },
  "156FC0800X": { classification: "Technician/Technologist", specialization: "Contact Lens" },
  "156FC0801X": {
    classification: "Technician/Technologist",
    specialization: "Contact Lens Fitter",
  },
  "156FX1700X": { classification: "Technician/Technologist", specialization: "Ocularist" },
  "156FX1100X": { classification: "Technician/Technologist", specialization: "Ophthalmic" },
  "156FX1101X": {
    classification: "Technician/Technologist",
    specialization: "Ophthalmic Assistant",
  },
  "156FX1800X": { classification: "Technician/Technologist", specialization: "Optician" },
  "156FX1201X": {
    classification: "Technician/Technologist",
    specialization: "Optometric Assistant",
  },
  "156FX1202X": {
    classification: "Technician/Technologist",
    specialization: "Optometric Technician",
  },
  "156FX1900X": { classification: "Technician/Technologist", specialization: "Orthoptist" },
  "164W00000X": { classification: "Licensed Practical Nurse", specialization: "" },
  "167G00000X": { classification: "Licensed Psychiatric Technician", specialization: "" },
  "164X00000X": { classification: "Licensed Vocational Nurse", specialization: "" },
  "163W00000X": { classification: "Registered Nurse", specialization: "" },
  "163WA0400X": {
    classification: "Registered Nurse",
    specialization: "Addiction (Substance Use Disorder)",
  },
  "163WA2000X": { classification: "Registered Nurse", specialization: "Administrator" },
  "163WP2201X": { classification: "Registered Nurse", specialization: "Ambulatory Care" },
  "163WC3500X": { classification: "Registered Nurse", specialization: "Cardiac Rehabilitation" },
  "163WC0400X": { classification: "Registered Nurse", specialization: "Case Management" },
  "163WC1400X": { classification: "Registered Nurse", specialization: "College Health" },
  "163WC1500X": { classification: "Registered Nurse", specialization: "Community Health" },
  "163WC2100X": { classification: "Registered Nurse", specialization: "Continence Care" },
  "163WC1600X": {
    classification: "Registered Nurse",
    specialization: "Continuing Education/Staff Development",
  },
  "163WC0200X": { classification: "Registered Nurse", specialization: "Critical Care Medicine" },
  "163WD0400X": { classification: "Registered Nurse", specialization: "Diabetes Educator" },
  "163WD1100X": { classification: "Registered Nurse", specialization: "Dialysis, Peritoneal" },
  "163WE0003X": { classification: "Registered Nurse", specialization: "Emergency" },
  "163WE0900X": { classification: "Registered Nurse", specialization: "Enterostomal Therapy" },
  "163WF0300X": { classification: "Registered Nurse", specialization: "Flight" },
  "163WG0100X": { classification: "Registered Nurse", specialization: "Gastroenterology" },
  "163WG0000X": { classification: "Registered Nurse", specialization: "General Practice" },
  "163WG0600X": { classification: "Registered Nurse", specialization: "Gerontology" },
  "163WH0500X": { classification: "Registered Nurse", specialization: "Hemodialysis" },
  "163WH0200X": { classification: "Registered Nurse", specialization: "Home Health" },
  "163WH1000X": { classification: "Registered Nurse", specialization: "Hospice" },
  "163WI0600X": { classification: "Registered Nurse", specialization: "Infection Control" },
  "163WI0500X": { classification: "Registered Nurse", specialization: "Infusion Therapy" },
  "163WL0100X": { classification: "Registered Nurse", specialization: "Lactation Consultant" },
  "163WM0102X": { classification: "Registered Nurse", specialization: "Maternal Newborn" },
  "163WM0705X": { classification: "Registered Nurse", specialization: "Medical-Surgical" },
  "163WN0002X": { classification: "Registered Nurse", specialization: "Neonatal Intensive Care" },
  "163WN0003X": { classification: "Registered Nurse", specialization: "Neonatal, Low-Risk" },
  "163WN0300X": { classification: "Registered Nurse", specialization: "Nephrology" },
  "163WN0800X": { classification: "Registered Nurse", specialization: "Neuroscience" },
  "163WM1400X": {
    classification: "Registered Nurse",
    specialization: "Nurse Massage Therapist (NMT)",
  },
  "163WN1003X": { classification: "Registered Nurse", specialization: "Nutrition Support" },
  "163WX0002X": { classification: "Registered Nurse", specialization: "Obstetric, High-Risk" },
  "163WX0003X": { classification: "Registered Nurse", specialization: "Obstetric, Inpatient" },
  "163WX0106X": { classification: "Registered Nurse", specialization: "Occupational Health" },
  "163WX0200X": { classification: "Registered Nurse", specialization: "Oncology" },
  "163WX1100X": { classification: "Registered Nurse", specialization: "Ophthalmic" },
  "163WX0800X": { classification: "Registered Nurse", specialization: "Orthopedic" },
  "163WX1500X": { classification: "Registered Nurse", specialization: "Ostomy Care" },
  "163WX0601X": {
    classification: "Registered Nurse",
    specialization: "Otorhinolaryngology & Head-Neck",
  },
  "163WP0000X": { classification: "Registered Nurse", specialization: "Pain Management" },
  "163WP0218X": { classification: "Registered Nurse", specialization: "Pediatric Oncology" },
  "163WP0200X": { classification: "Registered Nurse", specialization: "Pediatrics" },
  "163WP1700X": { classification: "Registered Nurse", specialization: "Perinatal" },
  "163WS0121X": { classification: "Registered Nurse", specialization: "Plastic Surgery" },
  "163WP0808X": { classification: "Registered Nurse", specialization: "Psychiatric/Mental Health" },
  "163WP0809X": {
    classification: "Registered Nurse",
    specialization: "Psychiatric/Mental Health, Adult",
  },
  "163WP0807X": {
    classification: "Registered Nurse",
    specialization: "Psychiatric/Mental Health, Child & Adolescent",
  },
  "163WR0006X": {
    classification: "Registered Nurse",
    specialization: "Registered Nurse First Assistant",
  },
  "163WR0400X": { classification: "Registered Nurse", specialization: "Rehabilitation" },
  "163WR1000X": {
    classification: "Registered Nurse",
    specialization: "Reproductive Endocrinology/Infertility",
  },
  "163WS0200X": { classification: "Registered Nurse", specialization: "School" },
  "163WU0100X": { classification: "Registered Nurse", specialization: "Urology" },
  "163WW0101X": {
    classification: "Registered Nurse",
    specialization: "Women's Health Care, Ambulatory",
  },
  "163WW0000X": { classification: "Registered Nurse", specialization: "Wound Care" },
  "372600000X": { classification: "Adult Companion", specialization: "" },
  "372500000X": { classification: "Chore Provider", specialization: "" },
  "373H00000X": { classification: "Day Training/Habilitation Specialist", specialization: "" },
  "374J00000X": { classification: "Doula", specialization: "" },
  "374U00000X": { classification: "Home Health Aide", specialization: "" },
  "376J00000X": { classification: "Homemaker", specialization: "" },
  "376K00000X": { classification: "Nurse's Aide", specialization: "" },
  "376G00000X": { classification: "Nursing Home Administrator", specialization: "" },
  "374T00000X": { classification: "Religious Nonmedical Nursing Personnel", specialization: "" },
  "374K00000X": { classification: "Religious Nonmedical Practitioner", specialization: "" },
  "374700000X": { classification: "Technician", specialization: "" },
  "3747A0650X": { classification: "Technician", specialization: "Attendant Care Provider" },
  "3747P1801X": { classification: "Technician", specialization: "Personal Care Attendant" },
  "171100000X": { classification: "Acupuncturist", specialization: "" },
  "171M00000X": { classification: "Case Manager/Care Coordinator", specialization: "" },
  "174V00000X": { classification: "Clinical Ethicist", specialization: "" },
  "172V00000X": { classification: "Community Health Worker", specialization: "" },
  "171W00000X": { classification: "Contractor", specialization: "" },
  "171WH0202X": { classification: "Contractor", specialization: "Home Modifications" },
  "171WV0202X": { classification: "Contractor", specialization: "Vehicle Modifications" },
  "172A00000X": { classification: "Driver", specialization: "" },
  "176P00000X": { classification: "Funeral Director", specialization: "" },
  "170300000X": { classification: "Genetic Counselor, MS", specialization: "" },
  "171400000X": { classification: "Health & Wellness Coach", specialization: "" },
  "174H00000X": { classification: "Health Educator", specialization: "" },
  "175L00000X": { classification: "Homeopath", specialization: "" },
  "171R00000X": { classification: "Interpreter", specialization: "" },
  "174N00000X": { classification: "Lactation Consultant, Non-RN", specialization: "" },
  "175M00000X": { classification: "Midwife, Lay", specialization: "" },
  "173000000X": { classification: "Legal Medicine", specialization: "" },
  "172M00000X": { classification: "Mechanotherapist", specialization: "" },
  "176B00000X": { classification: "Midwife", specialization: "" },
  "171000000X": { classification: "Military Health Care Provider", specialization: "" },
  "1710I1002X": {
    classification: "Military Health Care Provider",
    specialization: "Independent Duty Corpsman",
  },
  "1710I1003X": {
    classification: "Military Health Care Provider",
    specialization: "Independent Duty Medical Technicians",
  },
  "172P00000X": { classification: "Naprapath", specialization: "" },
  "175F00000X": { classification: "Naturopath", specialization: "" },
  "175T00000X": { classification: "Peer Specialist", specialization: "" },
  "170100000X": { classification: "Medical Genetics, Ph.D. Medical Genetics", specialization: "" },
  "405300000X": { classification: "Prevention Professional", specialization: "" },
  "173C00000X": { classification: "Reflexologist", specialization: "" },
  "173F00000X": { classification: "Sleep Specialist, PhD", specialization: "" },
  "174400000X": { classification: "Specialist", specialization: "" },
  "1744G0900X": { classification: "Specialist", specialization: "Graphics Designer" },
  "1744P3200X": { classification: "Specialist", specialization: "Prosthetics Case Management" },
  "1744R1103X": { classification: "Specialist", specialization: "Research Data Abstracter/Coder" },
  "1744R1102X": { classification: "Specialist", specialization: "Research Study" },
  "174M00000X": { classification: "Veterinarian", specialization: "" },
  "174MM1900X": { classification: "Veterinarian", specialization: "Medical Research" },
  "183500000X": { classification: "Pharmacist", specialization: "" },
  "1835P2201X": { classification: "Pharmacist", specialization: "Ambulatory Care" },
  "1835C0206X": { classification: "Pharmacist", specialization: "Cardiology" },
  "1835C0207X": { classification: "Pharmacist", specialization: "Compounded Sterile Preparations" },
  "1835C0205X": { classification: "Pharmacist", specialization: "Critical Care" },
  "1835E0208X": { classification: "Pharmacist", specialization: "Emergency Medicine" },
  "1835G0000X": { classification: "Pharmacist", specialization: "General Practice" },
  "1835G0303X": { classification: "Pharmacist", specialization: "Geriatric" },
  "1835I0206X": { classification: "Pharmacist", specialization: "Infectious Diseases" },
  "1835N0905X": { classification: "Pharmacist", specialization: "Nuclear" },
  "1835N1003X": { classification: "Pharmacist", specialization: "Nutrition Support" },
  "1835X0200X": { classification: "Pharmacist", specialization: "Oncology" },
  "1835P1400X": { classification: "Pharmacist", specialization: "Pain Management" },
  "1835P0200X": { classification: "Pharmacist", specialization: "Pediatrics" },
  "1835P0018X": {
    classification: "Pharmacist",
    specialization: "Pharmacist Clinician (PhC)/ Clinical Pharmacy Specialist",
  },
  "1835P1200X": { classification: "Pharmacist", specialization: "Pharmacotherapy" },
  "1835P1300X": { classification: "Pharmacist", specialization: "Psychiatric" },
  "1835S0206X": { classification: "Pharmacist", specialization: "Solid Organ Transplant" },
  "183700000X": { classification: "Pharmacy Technician", specialization: "" },
  "367A00000X": { classification: "Advanced Practice Midwife", specialization: "" },
  "367H00000X": { classification: "Anesthesiologist Assistant", specialization: "" },
  "364S00000X": { classification: "Clinical Nurse Specialist", specialization: "" },
  "364SA2100X": { classification: "Clinical Nurse Specialist", specialization: "Acute Care" },
  "364SA2200X": { classification: "Clinical Nurse Specialist", specialization: "Adult Health" },
  "364SC2300X": { classification: "Clinical Nurse Specialist", specialization: "Chronic Care" },
  "364SC1501X": {
    classification: "Clinical Nurse Specialist",
    specialization: "Community Health/Public Health",
  },
  "364SC0200X": {
    classification: "Clinical Nurse Specialist",
    specialization: "Critical Care Medicine",
  },
  "364SE0003X": { classification: "Clinical Nurse Specialist", specialization: "Emergency" },
  "364SE1400X": { classification: "Clinical Nurse Specialist", specialization: "Ethics" },
  "364SF0001X": { classification: "Clinical Nurse Specialist", specialization: "Family Health" },
  "364SG0600X": { classification: "Clinical Nurse Specialist", specialization: "Gerontology" },
  "364SH1100X": { classification: "Clinical Nurse Specialist", specialization: "Holistic" },
  "364SH0200X": { classification: "Clinical Nurse Specialist", specialization: "Home Health" },
  "364SI0800X": { classification: "Clinical Nurse Specialist", specialization: "Informatics" },
  "364SL0600X": { classification: "Clinical Nurse Specialist", specialization: "Long-Term Care" },
  "364SM0705X": { classification: "Clinical Nurse Specialist", specialization: "Medical-Surgical" },
  "364SN0000X": { classification: "Clinical Nurse Specialist", specialization: "Neonatal" },
  "364SN0800X": { classification: "Clinical Nurse Specialist", specialization: "Neuroscience" },
  "364SX0106X": {
    classification: "Clinical Nurse Specialist",
    specialization: "Occupational Health",
  },
  "364SX0200X": { classification: "Clinical Nurse Specialist", specialization: "Oncology" },
  "364SX0204X": {
    classification: "Clinical Nurse Specialist",
    specialization: "Oncology, Pediatrics",
  },
  "364SP0200X": { classification: "Clinical Nurse Specialist", specialization: "Pediatrics" },
  "364SP1700X": { classification: "Clinical Nurse Specialist", specialization: "Perinatal" },
  "364SP2800X": { classification: "Clinical Nurse Specialist", specialization: "Perioperative" },
  "364SP0808X": {
    classification: "Clinical Nurse Specialist",
    specialization: "Psychiatric/Mental Health",
  },
  "364SP0809X": {
    classification: "Clinical Nurse Specialist",
    specialization: "Psychiatric/Mental Health, Adult",
  },
  "364SP0807X": {
    classification: "Clinical Nurse Specialist",
    specialization: "Psychiatric/Mental Health, Child & Adolescent",
  },
  "364SP0810X": {
    classification: "Clinical Nurse Specialist",
    specialization: "Psychiatric/Mental Health, Child & Family",
  },
  "364SP0811X": {
    classification: "Clinical Nurse Specialist",
    specialization: "Psychiatric/Mental Health, Chronically Ill",
  },
  "364SP0812X": {
    classification: "Clinical Nurse Specialist",
    specialization: "Psychiatric/Mental Health, Community",
  },
  "364SP0813X": {
    classification: "Clinical Nurse Specialist",
    specialization: "Psychiatric/Mental Health, Geropsychiatric",
  },
  "364SR0400X": { classification: "Clinical Nurse Specialist", specialization: "Rehabilitation" },
  "364SS0200X": { classification: "Clinical Nurse Specialist", specialization: "School" },
  "364ST0500X": { classification: "Clinical Nurse Specialist", specialization: "Transplantation" },
  "364SW0102X": { classification: "Clinical Nurse Specialist", specialization: "Women's Health" },
  "367500000X": { classification: "Nurse Anesthetist, Certified Registered", specialization: "" },
  "363L00000X": { classification: "Nurse Practitioner", specialization: "" },
  "363LA2100X": { classification: "Nurse Practitioner", specialization: "Acute Care" },
  "363LA2200X": { classification: "Nurse Practitioner", specialization: "Adult Health" },
  "363LC1500X": { classification: "Nurse Practitioner", specialization: "Community Health" },
  "363LC0200X": { classification: "Nurse Practitioner", specialization: "Critical Care Medicine" },
  "363LF0000X": { classification: "Nurse Practitioner", specialization: "Family" },
  "363LG0600X": { classification: "Nurse Practitioner", specialization: "Gerontology" },
  "363LN0000X": { classification: "Nurse Practitioner", specialization: "Neonatal" },
  "363LN0005X": { classification: "Nurse Practitioner", specialization: "Neonatal, Critical Care" },
  "363LX0001X": { classification: "Nurse Practitioner", specialization: "Obstetrics & Gynecology" },
  "363LX0106X": { classification: "Nurse Practitioner", specialization: "Occupational Health" },
  "363LP0200X": { classification: "Nurse Practitioner", specialization: "Pediatrics" },
  "363LP0222X": {
    classification: "Nurse Practitioner",
    specialization: "Pediatrics, Critical Care",
  },
  "363LP1700X": { classification: "Nurse Practitioner", specialization: "Perinatal" },
  "363LP2300X": { classification: "Nurse Practitioner", specialization: "Primary Care" },
  "363LP0808X": {
    classification: "Nurse Practitioner",
    specialization: "Psychiatric/Mental Health",
  },
  "363LS0200X": { classification: "Nurse Practitioner", specialization: "School" },
  "363LW0102X": { classification: "Nurse Practitioner", specialization: "Women's Health" },
  "363A00000X": { classification: "Physician Assistant", specialization: "" },
  "363AM0700X": { classification: "Physician Assistant", specialization: "Medical" },
  "363AS0400X": { classification: "Physician Assistant", specialization: "Surgical" },
  "211D00000X": { classification: "Assistant, Podiatric", specialization: "" },
  "213E00000X": { classification: "Podiatrist", specialization: "" },
  "213ES0103X": { classification: "Podiatrist", specialization: "Foot & Ankle Surgery" },
  "213ES0131X": { classification: "Podiatrist", specialization: "Foot Surgery" },
  "213EG0000X": { classification: "Podiatrist", specialization: "General Practice" },
  "213EP1101X": { classification: "Podiatrist", specialization: "Primary Podiatric Medicine" },
  "213EP0504X": { classification: "Podiatrist", specialization: "Public Medicine" },
  "213ER0200X": { classification: "Podiatrist", specialization: "Radiology" },
  "213ES0000X": { classification: "Podiatrist", specialization: "Sports Medicine" },
  "229N00000X": { classification: "Anaplastologist", specialization: "" },
  "221700000X": { classification: "Art Therapist", specialization: "" },
  "224Y00000X": { classification: "Clinical Exercise Physiologist", specialization: "" },
  "225600000X": { classification: "Dance Therapist", specialization: "" },
  "222Q00000X": { classification: "Developmental Therapist", specialization: "" },
  "226300000X": { classification: "Kinesiotherapist", specialization: "" },
  "225700000X": { classification: "Massage Therapist", specialization: "" },
  "224900000X": { classification: "Mastectomy Fitter", specialization: "" },
  "225A00000X": { classification: "Music Therapist", specialization: "" },
  "225X00000X": { classification: "Occupational Therapist", specialization: "" },
  "225XR0403X": {
    classification: "Occupational Therapist",
    specialization: "Driving and Community Mobility",
  },
  "225XE0001X": {
    classification: "Occupational Therapist",
    specialization: "Environmental Modification",
  },
  "225XE1200X": { classification: "Occupational Therapist", specialization: "Ergonomics" },
  "225XF0002X": {
    classification: "Occupational Therapist",
    specialization: "Feeding, Eating & Swallowing",
  },
  "225XG0600X": { classification: "Occupational Therapist", specialization: "Gerontology" },
  "225XH1200X": { classification: "Occupational Therapist", specialization: "Hand" },
  "225XH1300X": { classification: "Occupational Therapist", specialization: "Human Factors" },
  "225XL0004X": { classification: "Occupational Therapist", specialization: "Low Vision" },
  "225XM0800X": { classification: "Occupational Therapist", specialization: "Mental Health" },
  "225XN1300X": { classification: "Occupational Therapist", specialization: "Neurorehabilitation" },
  "225XP0200X": { classification: "Occupational Therapist", specialization: "Pediatrics" },
  "225XP0019X": {
    classification: "Occupational Therapist",
    specialization: "Physical Rehabilitation",
  },
  "224Z00000X": { classification: "Occupational Therapy Assistant", specialization: "" },
  "224ZR0403X": {
    classification: "Occupational Therapy Assistant",
    specialization: "Driving and Community Mobility",
  },
  "224ZE0001X": {
    classification: "Occupational Therapy Assistant",
    specialization: "Environmental Modification",
  },
  "224ZF0002X": {
    classification: "Occupational Therapy Assistant",
    specialization: "Feeding, Eating & Swallowing",
  },
  "224ZL0004X": { classification: "Occupational Therapy Assistant", specialization: "Low Vision" },
  "225000000X": { classification: "Orthotic Fitter", specialization: "" },
  "222Z00000X": { classification: "Orthotist", specialization: "" },
  "224L00000X": { classification: "Pedorthist", specialization: "" },
  "225100000X": { classification: "Physical Therapist", specialization: "" },
  "2251C2600X": { classification: "Physical Therapist", specialization: "Cardiopulmonary" },
  "2251E1300X": {
    classification: "Physical Therapist",
    specialization: "Electrophysiology, Clinical",
  },
  "2251E1200X": { classification: "Physical Therapist", specialization: "Ergonomics" },
  "2251G0304X": { classification: "Physical Therapist", specialization: "Geriatrics" },
  "2251H1200X": { classification: "Physical Therapist", specialization: "Hand" },
  "2251H1300X": { classification: "Physical Therapist", specialization: "Human Factors" },
  "2251N0400X": { classification: "Physical Therapist", specialization: "Neurology" },
  "2251X0800X": { classification: "Physical Therapist", specialization: "Orthopedic" },
  "2251P0200X": { classification: "Physical Therapist", specialization: "Pediatrics" },
  "2251S0007X": { classification: "Physical Therapist", specialization: "Sports" },
  "225200000X": { classification: "Physical Therapy Assistant", specialization: "" },
  "224P00000X": { classification: "Prosthetist", specialization: "" },
  "225B00000X": { classification: "Pulmonary Function Technologist", specialization: "" },
  "225800000X": { classification: "Recreation Therapist", specialization: "" },
  "226000000X": { classification: "Recreational Therapist Assistant", specialization: "" },
  "225C00000X": { classification: "Rehabilitation Counselor", specialization: "" },
  "225CA2400X": {
    classification: "Rehabilitation Counselor",
    specialization: "Assistive Technology Practitioner",
  },
  "225CA2500X": {
    classification: "Rehabilitation Counselor",
    specialization: "Assistive Technology Supplier",
  },
  "225CX0006X": {
    classification: "Rehabilitation Counselor",
    specialization: "Orientation and Mobility Training Provider",
  },
  "225400000X": { classification: "Rehabilitation Practitioner", specialization: "" },
  "227800000X": { classification: "Respiratory Therapist, Certified", specialization: "" },
  "2278C0205X": {
    classification: "Respiratory Therapist, Certified",
    specialization: "Critical Care",
  },
  "2278E1000X": {
    classification: "Respiratory Therapist, Certified",
    specialization: "Educational",
  },
  "2278E0002X": {
    classification: "Respiratory Therapist, Certified",
    specialization: "Emergency Care",
  },
  "2278G1100X": {
    classification: "Respiratory Therapist, Certified",
    specialization: "General Care",
  },
  "2278G0305X": {
    classification: "Respiratory Therapist, Certified",
    specialization: "Geriatric Care",
  },
  "2278H0200X": {
    classification: "Respiratory Therapist, Certified",
    specialization: "Home Health",
  },
  "2278P3900X": {
    classification: "Respiratory Therapist, Certified",
    specialization: "Neonatal/Pediatrics",
  },
  "2278P3800X": {
    classification: "Respiratory Therapist, Certified",
    specialization: "Palliative/Hospice",
  },
  "2278P4000X": {
    classification: "Respiratory Therapist, Certified",
    specialization: "Patient Transport",
  },
  "2278P1004X": {
    classification: "Respiratory Therapist, Certified",
    specialization: "Pulmonary Diagnostics",
  },
  "2278P1006X": {
    classification: "Respiratory Therapist, Certified",
    specialization: "Pulmonary Function Technologist",
  },
  "2278P1005X": {
    classification: "Respiratory Therapist, Certified",
    specialization: "Pulmonary Rehabilitation",
  },
  "2278S1500X": {
    classification: "Respiratory Therapist, Certified",
    specialization: "SNF/Subacute Care",
  },
  "227900000X": { classification: "Respiratory Therapist, Registered", specialization: "" },
  "2279C0205X": {
    classification: "Respiratory Therapist, Registered",
    specialization: "Critical Care",
  },
  "2279E1000X": {
    classification: "Respiratory Therapist, Registered",
    specialization: "Educational",
  },
  "2279E0002X": {
    classification: "Respiratory Therapist, Registered",
    specialization: "Emergency Care",
  },
  "2279G1100X": {
    classification: "Respiratory Therapist, Registered",
    specialization: "General Care",
  },
  "2279G0305X": {
    classification: "Respiratory Therapist, Registered",
    specialization: "Geriatric Care",
  },
  "2279H0200X": {
    classification: "Respiratory Therapist, Registered",
    specialization: "Home Health",
  },
  "2279P3900X": {
    classification: "Respiratory Therapist, Registered",
    specialization: "Neonatal/Pediatrics",
  },
  "2279P3800X": {
    classification: "Respiratory Therapist, Registered",
    specialization: "Palliative/Hospice",
  },
  "2279P4000X": {
    classification: "Respiratory Therapist, Registered",
    specialization: "Patient Transport",
  },
  "2279P1004X": {
    classification: "Respiratory Therapist, Registered",
    specialization: "Pulmonary Diagnostics",
  },
  "2279P1006X": {
    classification: "Respiratory Therapist, Registered",
    specialization: "Pulmonary Function Technologist",
  },
  "2279P1005X": {
    classification: "Respiratory Therapist, Registered",
    specialization: "Pulmonary Rehabilitation",
  },
  "2279S1500X": {
    classification: "Respiratory Therapist, Registered",
    specialization: "SNF/Subacute Care",
  },
  "225500000X": { classification: "Specialist/Technologist", specialization: "" },
  "2255A2300X": { classification: "Specialist/Technologist", specialization: "Athletic Trainer" },
  "2255R0406X": {
    classification: "Specialist/Technologist",
    specialization: "Rehabilitation, Blind",
  },
  "231H00000X": { classification: "Audiologist", specialization: "" },
  "231HA2400X": {
    classification: "Audiologist",
    specialization: "Assistive Technology Practitioner",
  },
  "231HA2500X": { classification: "Audiologist", specialization: "Assistive Technology Supplier" },
  "237600000X": { classification: "Audiologist-Hearing Aid Fitter", specialization: "" },
  "237700000X": { classification: "Hearing Instrument Specialist", specialization: "" },
  "235500000X": { classification: "Specialist/Technologist", specialization: "" },
  "2355A2700X": {
    classification: "Specialist/Technologist",
    specialization: "Audiology Assistant",
  },
  "2355S0801X": {
    classification: "Specialist/Technologist",
    specialization: "Speech-Language Assistant",
  },
  "235Z00000X": { classification: "Speech-Language Pathologist", specialization: "" },
  "390200000X": {
    classification: "Student in an Organized Health Care Education/Training Program",
    specialization: "",
  },
  "242T00000X": { classification: "Perfusionist", specialization: "" },
  "247100000X": { classification: "Radiologic Technologist", specialization: "" },
  "2471B0102X": { classification: "Radiologic Technologist", specialization: "Bone Densitometry" },
  "2471C1106X": {
    classification: "Radiologic Technologist",
    specialization: "Cardiac-Interventional Technology",
  },
  "2471C1101X": {
    classification: "Radiologic Technologist",
    specialization: "Cardiovascular-Interventional Technology",
  },
  "2471C3401X": {
    classification: "Radiologic Technologist",
    specialization: "Computed Tomography",
  },
  "2471M1202X": {
    classification: "Radiologic Technologist",
    specialization: "Magnetic Resonance Imaging",
  },
  "2471M2300X": { classification: "Radiologic Technologist", specialization: "Mammography" },
  "2471N0900X": {
    classification: "Radiologic Technologist",
    specialization: "Nuclear Medicine Technology",
  },
  "2471Q0001X": { classification: "Radiologic Technologist", specialization: "Quality Management" },
  "2471R0002X": { classification: "Radiologic Technologist", specialization: "Radiation Therapy" },
  "2471C3402X": { classification: "Radiologic Technologist", specialization: "Radiography" },
  "2471S1302X": { classification: "Radiologic Technologist", specialization: "Sonography" },
  "2471V0105X": {
    classification: "Radiologic Technologist",
    specialization: "Vascular Sonography",
  },
  "2471V0106X": {
    classification: "Radiologic Technologist",
    specialization: "Vascular-Interventional Technology",
  },
  "243U00000X": { classification: "Radiology Practitioner Assistant", specialization: "" },
  "246X00000X": { classification: "Specialist/Technologist Cardiovascular", specialization: "" },
  "246XC2901X": {
    classification: "Specialist/Technologist Cardiovascular",
    specialization: "Cardiovascular Invasive Specialist",
  },
  "246XS1301X": {
    classification: "Specialist/Technologist Cardiovascular",
    specialization: "Sonography",
  },
  "246XC2903X": {
    classification: "Specialist/Technologist Cardiovascular",
    specialization: "Vascular Specialist",
  },
  "246Y00000X": {
    classification: "Specialist/Technologist, Health Information",
    specialization: "",
  },
  "246YC3301X": {
    classification: "Specialist/Technologist, Health Information",
    specialization: "Coding Specialist, Hospital Based",
  },
  "246YC3302X": {
    classification: "Specialist/Technologist, Health Information",
    specialization: "Coding Specialist, Physician Office Based",
  },
  "246YR1600X": {
    classification: "Specialist/Technologist, Health Information",
    specialization: "Registered Record Administrator",
  },
  "246Z00000X": { classification: "Specialist/Technologist, Other", specialization: "" },
  "246ZA2600X": {
    classification: "Specialist/Technologist, Other",
    specialization: "Art, Medical",
  },
  "246ZB0500X": { classification: "Specialist/Technologist, Other", specialization: "Biochemist" },
  "246ZB0301X": {
    classification: "Specialist/Technologist, Other",
    specialization: "Biomedical Engineering",
  },
  "246ZB0302X": {
    classification: "Specialist/Technologist, Other",
    specialization: "Biomedical Photographer",
  },
  "246ZB0600X": {
    classification: "Specialist/Technologist, Other",
    specialization: "Biostatistician",
  },
  "246ZE0500X": { classification: "Specialist/Technologist, Other", specialization: "EEG" },
  "246ZE0600X": {
    classification: "Specialist/Technologist, Other",
    specialization: "Electroneurodiagnostic",
  },
  "246ZG1000X": {
    classification: "Specialist/Technologist, Other",
    specialization: "Geneticist, Medical (PhD)",
  },
  "246ZG0701X": {
    classification: "Specialist/Technologist, Other",
    specialization: "Graphics Methods",
  },
  "246ZI1000X": {
    classification: "Specialist/Technologist, Other",
    specialization: "Illustration, Medical",
  },
  "246ZN0300X": { classification: "Specialist/Technologist, Other", specialization: "Nephrology" },
  "246ZX2200X": {
    classification: "Specialist/Technologist, Other",
    specialization: "Orthopedic Assistant",
  },
  "246ZC0007X": {
    classification: "Specialist/Technologist, Other",
    specialization: "Surgical Assistant",
  },
  "246ZS0410X": {
    classification: "Specialist/Technologist, Other",
    specialization: "Surgical Technologist",
  },
  "246Q00000X": { classification: "Specialist/Technologist, Pathology", specialization: "" },
  "246QB0000X": {
    classification: "Specialist/Technologist, Pathology",
    specialization: "Blood Banking",
  },
  "246QC1000X": {
    classification: "Specialist/Technologist, Pathology",
    specialization: "Chemistry",
  },
  "246QC2700X": {
    classification: "Specialist/Technologist, Pathology",
    specialization: "Cytotechnology",
  },
  "246QH0401X": {
    classification: "Specialist/Technologist, Pathology",
    specialization: "Hemapheresis Practitioner",
  },
  "246QH0000X": {
    classification: "Specialist/Technologist, Pathology",
    specialization: "Hematology",
  },
  "246QH0600X": {
    classification: "Specialist/Technologist, Pathology",
    specialization: "Histology",
  },
  "246QI0000X": {
    classification: "Specialist/Technologist, Pathology",
    specialization: "Immunology",
  },
  "246QL0900X": {
    classification: "Specialist/Technologist, Pathology",
    specialization: "Laboratory Management",
  },
  "246QL0901X": {
    classification: "Specialist/Technologist, Pathology",
    specialization: "Laboratory Management, Diplomate",
  },
  "246QM0706X": {
    classification: "Specialist/Technologist, Pathology",
    specialization: "Medical Technologist",
  },
  "246QM0900X": {
    classification: "Specialist/Technologist, Pathology",
    specialization: "Microbiology",
  },
  "246W00000X": { classification: "Technician, Cardiology", specialization: "" },
  "247000000X": { classification: "Technician, Health Information", specialization: "" },
  "2470A2800X": {
    classification: "Technician, Health Information",
    specialization: "Assistant Record Technician",
  },
  "247200000X": { classification: "Technician, Other", specialization: "" },
  "2472B0301X": { classification: "Technician, Other", specialization: "Biomedical Engineering" },
  "2472D0500X": { classification: "Technician, Other", specialization: "Darkroom" },
  "2472E0500X": { classification: "Technician, Other", specialization: "EEG" },
  "2472R0900X": { classification: "Technician, Other", specialization: "Renal Dialysis" },
  "2472V0600X": { classification: "Technician, Other", specialization: "Veterinary" },
  "246R00000X": { classification: "Technician, Pathology", specialization: "" },
  "247ZC0005X": {
    classification: "Technician, Pathology",
    specialization: "Clinical Laboratory Director, Non-physician",
  },
  "246RH0600X": { classification: "Technician, Pathology", specialization: "Histology" },
  "246RM2200X": { classification: "Technician, Pathology", specialization: "Medical Laboratory" },
  "246RP1900X": { classification: "Technician, Pathology", specialization: "Phlebotomy" },
  "251B00000X": { classification: "Case Management", specialization: "" },
  "251S00000X": { classification: "Community/Behavioral Health", specialization: "" },
  "251C00000X": {
    classification: "Day Training, Developmentally Disabled Services",
    specialization: "",
  },
  "252Y00000X": { classification: "Early Intervention Provider Agency", specialization: "" },
  "253J00000X": { classification: "Foster Care Agency", specialization: "" },
  "251E00000X": { classification: "Home Health", specialization: "" },
  "251F00000X": { classification: "Home Infusion", specialization: "" },
  "251G00000X": { classification: "Hospice Care, Community Based", specialization: "" },
  "253Z00000X": { classification: "In Home Supportive Care", specialization: "" },
  "251300000X": { classification: "Local Education Agency (LEA)", specialization: "" },
  "251J00000X": { classification: "Nursing Care", specialization: "" },
  "251T00000X": {
    classification: "Program of All-Inclusive Care for the Elderly (PACE) Provider Organization",
    specialization: "",
  },
  "251K00000X": { classification: "Public Health or Welfare", specialization: "" },
  "251X00000X": { classification: "Supports Brokerage", specialization: "" },
  "251V00000X": { classification: "Voluntary or Charitable", specialization: "" },
  "261Q00000X": { classification: "Clinic/Center", specialization: "" },
  "261QM0855X": {
    classification: "Clinic/Center",
    specialization: "Adolescent and Children Mental Health",
  },
  "261QA0600X": { classification: "Clinic/Center", specialization: "Adult Day Care" },
  "261QM0850X": { classification: "Clinic/Center", specialization: "Adult Mental Health" },
  "261QA0005X": {
    classification: "Clinic/Center",
    specialization: "Ambulatory Family Planning Facility",
  },
  "261QA0006X": {
    classification: "Clinic/Center",
    specialization: "Ambulatory Fertility Facility",
  },
  "261QA1903X": { classification: "Clinic/Center", specialization: "Ambulatory Surgical" },
  "261QA0900X": { classification: "Clinic/Center", specialization: "Amputee" },
  "261QA3000X": { classification: "Clinic/Center", specialization: "Augmentative Communication" },
  "261QB0400X": { classification: "Clinic/Center", specialization: "Birthing" },
  "261QC1500X": { classification: "Clinic/Center", specialization: "Community Health" },
  "261QC1800X": { classification: "Clinic/Center", specialization: "Corporate Health" },
  "261QC0050X": { classification: "Clinic/Center", specialization: "Critical Access Hospital" },
  "261QD0000X": { classification: "Clinic/Center", specialization: "Dental" },
  "261QD1600X": { classification: "Clinic/Center", specialization: "Developmental Disabilities" },
  "261QE0002X": { classification: "Clinic/Center", specialization: "Emergency Care" },
  "261QE0700X": {
    classification: "Clinic/Center",
    specialization: "End-Stage Renal Disease (ESRD) Treatment",
  },
  "261QE0800X": { classification: "Clinic/Center", specialization: "Endoscopy" },
  "261QF0050X": {
    classification: "Clinic/Center",
    specialization: "Family Planning, Non-Surgical",
  },
  "261QF0400X": {
    classification: "Clinic/Center",
    specialization: "Federally Qualified Health Center (FQHC)",
  },
  "261QG0250X": { classification: "Clinic/Center", specialization: "Genetics" },
  "261QH0100X": { classification: "Clinic/Center", specialization: "Health Service" },
  "261QH0700X": { classification: "Clinic/Center", specialization: "Hearing and Speech" },
  "261QI0500X": { classification: "Clinic/Center", specialization: "Infusion Therapy" },
  "261QL0400X": { classification: "Clinic/Center", specialization: "Lithotripsy" },
  "261QM1200X": {
    classification: "Clinic/Center",
    specialization: "Magnetic Resonance Imaging (MRI)",
  },
  "261QM2500X": { classification: "Clinic/Center", specialization: "Medical Specialty" },
  "261QM3000X": {
    classification: "Clinic/Center",
    specialization: "Medically Fragile Infants and Children Day Care",
  },
  "261QM0801X": {
    classification: "Clinic/Center",
    specialization: "Mental Health (Including Community Mental Health Center)",
  },
  "261QM2800X": { classification: "Clinic/Center", specialization: "Methadone" },
  "261QM1000X": { classification: "Clinic/Center", specialization: "Migrant Health" },
  "261QM1103X": {
    classification: "Clinic/Center",
    specialization: "Military Ambulatory Procedure Visits Operational (Transportable)",
  },
  "261QM1101X": {
    classification: "Clinic/Center",
    specialization: "Military and U.S. Coast Guard Ambulatory Procedure",
  },
  "261QM1102X": {
    classification: "Clinic/Center",
    specialization: "Military Outpatient Operational (Transportable) Component",
  },
  "261QM1100X": {
    classification: "Clinic/Center",
    specialization: "Military/U.S. Coast Guard Outpatient",
  },
  "261QM1300X": { classification: "Clinic/Center", specialization: "Multi-Specialty" },
  "261QX0100X": { classification: "Clinic/Center", specialization: "Occupational Medicine" },
  "261QX0200X": { classification: "Clinic/Center", specialization: "Oncology" },
  "261QX0203X": { classification: "Clinic/Center", specialization: "Oncology, Radiation" },
  "261QS0132X": { classification: "Clinic/Center", specialization: "Ophthalmologic Surgery" },
  "261QS0112X": {
    classification: "Clinic/Center",
    specialization: "Oral and Maxillofacial Surgery",
  },
  "261QP3300X": { classification: "Clinic/Center", specialization: "Pain" },
  "261QP2000X": { classification: "Clinic/Center", specialization: "Physical Therapy" },
  "261QP1100X": { classification: "Clinic/Center", specialization: "Podiatric" },
  "261QP2300X": { classification: "Clinic/Center", specialization: "Primary Care" },
  "261QP2400X": { classification: "Clinic/Center", specialization: "Prison Health" },
  "261QP0904X": { classification: "Clinic/Center", specialization: "Public Health, Federal" },
  "261QP0905X": {
    classification: "Clinic/Center",
    specialization: "Public Health, State or Local",
  },
  "261QR0200X": { classification: "Clinic/Center", specialization: "Radiology" },
  "261QR0206X": { classification: "Clinic/Center", specialization: "Radiology, Mammography" },
  "261QR0208X": { classification: "Clinic/Center", specialization: "Radiology, Mobile" },
  "261QR0207X": {
    classification: "Clinic/Center",
    specialization: "Radiology, Mobile Mammography",
  },
  "261QR0800X": { classification: "Clinic/Center", specialization: "Recovery Care" },
  "261QR0400X": { classification: "Clinic/Center", specialization: "Rehabilitation" },
  "261QR0404X": {
    classification: "Clinic/Center",
    specialization: "Rehabilitation, Cardiac Facilities",
  },
  "261QR0401X": {
    classification: "Clinic/Center",
    specialization: "Rehabilitation, Comprehensive Outpatient Rehabilitation Facility (CORF)",
  },
  "261QR0405X": {
    classification: "Clinic/Center",
    specialization: "Rehabilitation, Substance Use Disorder",
  },
  "261QR1100X": { classification: "Clinic/Center", specialization: "Research" },
  "261QR1300X": { classification: "Clinic/Center", specialization: "Rural Health" },
  "261QS1200X": { classification: "Clinic/Center", specialization: "Sleep Disorder Diagnostic" },
  "261QS1000X": { classification: "Clinic/Center", specialization: "Student Health" },
  "261QU0200X": { classification: "Clinic/Center", specialization: "Urgent Care" },
  "261QV0200X": { classification: "Clinic/Center", specialization: "VA" },
  "273100000X": { classification: "Epilepsy Unit", specialization: "" },
  "275N00000X": { classification: "Medicare Defined Swing Bed Unit", specialization: "" },
  "273R00000X": { classification: "Psychiatric Unit", specialization: "" },
  "273Y00000X": { classification: "Rehabilitation Unit", specialization: "" },
  "276400000X": {
    classification: "Rehabilitation, Substance Use Disorder Unit",
    specialization: "",
  },
  "287300000X": { classification: "Christian Science Sanitorium", specialization: "" },
  "281P00000X": { classification: "Chronic Disease Hospital", specialization: "" },
  "281PC2000X": { classification: "Chronic Disease Hospital", specialization: "Children" },
  "282N00000X": { classification: "General Acute Care Hospital", specialization: "" },
  "282NC2000X": { classification: "General Acute Care Hospital", specialization: "Children" },
  "282NC0060X": {
    classification: "General Acute Care Hospital",
    specialization: "Critical Access",
  },
  "282NR1301X": { classification: "General Acute Care Hospital", specialization: "Rural" },
  "282NW0100X": { classification: "General Acute Care Hospital", specialization: "Women" },
  "282E00000X": { classification: "Long Term Care Hospital", specialization: "" },
  "286500000X": { classification: "Military Hospital", specialization: "" },
  "2865C1500X": { classification: "Military Hospital", specialization: "Community Health" },
  "2865M2000X": {
    classification: "Military Hospital",
    specialization: "Military General Acute Care Hospital",
  },
  "2865X1600X": {
    classification: "Military Hospital",
    specialization: "Military General Acute Care Hospital. Operational (Transportable)",
  },
  "283Q00000X": { classification: "Psychiatric Hospital", specialization: "" },
  "283X00000X": { classification: "Rehabilitation Hospital", specialization: "" },
  "283XC2000X": { classification: "Rehabilitation Hospital", specialization: "Children" },
  "282J00000X": {
    classification: "Religious Nonmedical Health Care Institution",
    specialization: "",
  },
  "284300000X": { classification: "Special Hospital", specialization: "" },
  "291U00000X": { classification: "Clinical Medical Laboratory", specialization: "" },
  "292200000X": { classification: "Dental Laboratory", specialization: "" },
  "291900000X": { classification: "Military Clinical Medical Laboratory", specialization: "" },
  "293D00000X": { classification: "Physiological Laboratory", specialization: "" },
  "302F00000X": { classification: "Exclusive Provider Organization", specialization: "" },
  "302R00000X": { classification: "Health Maintenance Organization", specialization: "" },
  "305S00000X": { classification: "Point of Service", specialization: "" },
  "305R00000X": { classification: "Preferred Provider Organization", specialization: "" },
  "311500000X": { classification: "Alzheimer Center (Dementia Center)", specialization: "" },
  "310400000X": { classification: "Assisted Living Facility", specialization: "" },
  "3104A0630X": {
    classification: "Assisted Living Facility",
    specialization: "Assisted Living, Behavioral Disturbances",
  },
  "3104A0625X": {
    classification: "Assisted Living Facility",
    specialization: "Assisted Living, Mental Illness",
  },
  "317400000X": { classification: "Christian Science Facility", specialization: "" },
  "311Z00000X": { classification: "Custodial Care Facility", specialization: "" },
  "311ZA0620X": { classification: "Custodial Care Facility", specialization: "Adult Care Home" },
  "315D00000X": { classification: "Hospice, Inpatient", specialization: "" },
  "315P00000X": {
    classification: "Intermediate Care Facility, Intellectual Disabilities",
    specialization: "",
  },
  "310500000X": {
    classification: "Intermediate Care Facility, Mental Illness",
    specialization: "",
  },
  "313M00000X": {
    classification: "Nursing Facility/Intermediate Care Facility",
    specialization: "",
  },
  "314000000X": { classification: "Skilled Nursing Facility", specialization: "" },
  "3140N1450X": {
    classification: "Skilled Nursing Facility",
    specialization: "Nursing Care, Pediatric",
  },
  "177F00000X": { classification: "Lodging", specialization: "" },
  "174200000X": { classification: "Meals", specialization: "" },
  "320800000X": {
    classification: "Community Based Residential Treatment Facility, Mental Illness",
    specialization: "",
  },
  "320900000X": {
    classification:
      "Community Based Residential Treatment Facility, Intellectual and/or Developmental Disabilities",
    specialization: "",
  },
  "323P00000X": {
    classification: "Psychiatric Residential Treatment Facility",
    specialization: "",
  },
  "322D00000X": {
    classification: "Residential Treatment Facility, Emotionally Disturbed Children",
    specialization: "",
  },
  "320600000X": {
    classification:
      "Residential Treatment Facility, Intellectual and/or Developmental Disabilities",
    specialization: "",
  },
  "320700000X": {
    classification: "Residential Treatment Facility, Physical Disabilities",
    specialization: "",
  },
  "324500000X": { classification: "Substance Abuse Rehabilitation Facility", specialization: "" },
  "3245S0500X": {
    classification: "Substance Abuse Rehabilitation Facility",
    specialization: "Substance Abuse Treatment, Children",
  },
  "385H00000X": { classification: "Respite Care", specialization: "" },
  "385HR2050X": { classification: "Respite Care", specialization: "Respite Care Camp" },
  "385HR2055X": {
    classification: "Respite Care",
    specialization: "Respite Care, Mental Illness, Child",
  },
  "385HR2060X": {
    classification: "Respite Care",
    specialization: "Respite Care, Intellectual and/or Developmental Disabilities, Child",
  },
  "385HR2065X": {
    classification: "Respite Care",
    specialization: "Respite Care, Physical Disabilities, Child",
  },
  "331L00000X": { classification: "Blood Bank", specialization: "" },
  "332100000X": {
    classification: "Department of Veterans Affairs (VA) Pharmacy",
    specialization: "",
  },
  "332B00000X": {
    classification: "Durable Medical Equipment & Medical Supplies",
    specialization: "",
  },
  "332BC3200X": {
    classification: "Durable Medical Equipment & Medical Supplies",
    specialization: "Customized Equipment",
  },
  "332BD1200X": {
    classification: "Durable Medical Equipment & Medical Supplies",
    specialization: "Dialysis Equipment & Supplies",
  },
  "332BN1400X": {
    classification: "Durable Medical Equipment & Medical Supplies",
    specialization: "Nursing Facility Supplies",
  },
  "332BX2000X": {
    classification: "Durable Medical Equipment & Medical Supplies",
    specialization: "Oxygen Equipment & Supplies",
  },
  "332BP3500X": {
    classification: "Durable Medical Equipment & Medical Supplies",
    specialization: "Parenteral & Enteral Nutrition",
  },
  "333300000X": { classification: "Emergency Response System Companies", specialization: "" },
  "332G00000X": { classification: "Eye Bank", specialization: "" },
  "332H00000X": { classification: "Eyewear Supplier", specialization: "" },
  "332S00000X": { classification: "Hearing Aid Equipment", specialization: "" },
  "332U00000X": { classification: "Home Delivered Meals", specialization: "" },
  "332800000X": {
    classification: "Indian Health Service/Tribal/Urban Indian Health (I/T/U) Pharmacy",
    specialization: "",
  },
  "335G00000X": { classification: "Medical Foods Supplier", specialization: "" },
  "332000000X": { classification: "Military/U.S. Coast Guard Pharmacy", specialization: "" },
  "332900000X": { classification: "Non-Pharmacy Dispensing Site", specialization: "" },
  "335U00000X": { classification: "Organ Procurement Organization", specialization: "" },
  "333600000X": { classification: "Pharmacy", specialization: "" },
  "3336C0002X": { classification: "Pharmacy", specialization: "Clinic Pharmacy" },
  "3336C0003X": { classification: "Pharmacy", specialization: "Community/Retail Pharmacy" },
  "3336C0004X": { classification: "Pharmacy", specialization: "Compounding Pharmacy" },
  "3336H0001X": { classification: "Pharmacy", specialization: "Home Infusion Therapy Pharmacy" },
  "3336I0012X": { classification: "Pharmacy", specialization: "Institutional Pharmacy" },
  "3336L0003X": { classification: "Pharmacy", specialization: "Long Term Care Pharmacy" },
  "3336M0002X": { classification: "Pharmacy", specialization: "Mail Order Pharmacy" },
  "3336M0003X": {
    classification: "Pharmacy",
    specialization: "Managed Care Organization Pharmacy",
  },
  "3336N0007X": { classification: "Pharmacy", specialization: "Nuclear Pharmacy" },
  "3336S0011X": { classification: "Pharmacy", specialization: "Specialty Pharmacy" },
  "335V00000X": {
    classification: "Portable X-ray and/or Other Portable Diagnostic Imaging Supplier",
    specialization: "",
  },
  "335E00000X": { classification: "Prosthetic/Orthotic Supplier", specialization: "" },
  "344800000X": { classification: "Air Carrier", specialization: "" },
  "341600000X": { classification: "Ambulance", specialization: "" },
  "3416A0800X": { classification: "Ambulance", specialization: "Air Transport" },
  "3416L0300X": { classification: "Ambulance", specialization: "Land Transport" },
  "3416S0300X": { classification: "Ambulance", specialization: "Water Transport" },
  "347B00000X": { classification: "Bus", specialization: "" },
  "341800000X": { classification: "Military/U.S. Coast Guard Transport", specialization: "" },
  "3418M1120X": {
    classification: "Military/U.S. Coast Guard Transport",
    specialization: "Military or U.S. Coast Guard Ambulance, Air Transport",
  },
  "3418M1110X": {
    classification: "Military/U.S. Coast Guard Transport",
    specialization: "Military or U.S. Coast Guard Ambulance, Ground Transport",
  },
  "3418M1130X": {
    classification: "Military/U.S. Coast Guard Transport",
    specialization: "Military or U.S. Coast Guard Ambulance, Water Transport",
  },
  "343900000X": { classification: "Non-emergency Medical Transport (VAN)", specialization: "" },
  "347C00000X": { classification: "Private Vehicle", specialization: "" },
  "343800000X": { classification: "Secured Medical Transport (VAN)", specialization: "" },
  "344600000X": { classification: "Taxi", specialization: "" },
  "347D00000X": { classification: "Train", specialization: "" },
  "347E00000X": { classification: "Transportation Broker", specialization: "" },
  "342000000X": { classification: "Transportation Network Company", specialization: "" },
} as const;

/**
 * Organization name keyword mappings for specialty detection
 */
export const ORGANIZATION_SPECIALTY_KEYWORDS = {
  // Cardiology
  cardiology: "Cardiovascular",
  cardiac: "Cardiovascular",
  heart: "Cardiovascular",
  cardiovascular: "Cardiovascular",

  // Pulmonology
  pulmonology: "Pulmonary",
  pulmonary: "Pulmonary",
  lung: "Pulmonary",
  respiratory: "Pulmonary",

  // Oncology
  oncology: "Medical Oncology",
  cancer: "Medical Oncology",
  tumor: "Medical Oncology",
  hematology: "Hematology",

  // Emergency Medicine
  emergency: "Emergency Medicine",
  trauma: "Emergency Medicine",
  urgent: "Emergency Medicine",

  // Surgery
  surgery: "Orthopaedic Surgery",
  surgical: "Orthopaedic Surgery",
  orthopedic: "Orthopaedic Surgery",
  orthopaedic: "Orthopaedic Surgery",
  neurosurgery: "Neurological Surgery",

  // Internal Medicine
  internal: "Internal Medicine",
  medicine: "Internal Medicine",

  // Radiology
  radiology: "Nuclear Medicine",
  imaging: "Nuclear Medicine",

  // Psychiatry
  psychiatry: "Psychiatry",
  mental: "Psychiatry",
  behavioral: "Psychiatry",

  // Family Medicine
  family: "Family Medicine",
  primary: "Family Medicine",

  // Dermatology
  dermatology: "Dermatology",
  skin: "Dermatology",

  // Anesthesiology
  anesthesiology: "Anesthesiology",
  anesthesia: "Anesthesiology",

  // Pathology
  pathology: "Anatomic Pathology & Clinical Pathology",
  laboratory: "Anatomic Pathology & Clinical Pathology",

  // Pediatrics
  pediatrics: "Pediatrics",
  pediatric: "Pediatrics",
  children: "Pediatrics",

  // Obstetrics & Gynecology
  obstetrics: "Obstetrics & Gynecology",
  gynecology: "Obstetrics & Gynecology",
  women: "Obstetrics & Gynecology",

  // Ophthalmology
  ophthalmology: "Ophthalmology",
  eye: "Ophthalmology",
  vision: "Ophthalmology",

  // Otolaryngology
  otolaryngology: "Otolaryngology",
  ear: "Otolaryngology",
  nose: "Otolaryngology",
  throat: "Otolaryngology",

  // Pain Medicine
  pain: "Pain Medicine",

  // Allergy & Immunology
  allergy: "Allergy & Immunology",
  immunology: "Allergy & Immunology",

  // Gastroenterology
  gastroenterology: "Gastroenterology",
  gastro: "Gastroenterology",

  // Nephrology
  nephrology: "Nephrology",
  kidney: "Nephrology",

  // Endocrinology
  endocrinology: "Endocrinology, Diabetes & Metabolism",
  diabetes: "Endocrinology, Diabetes & Metabolism",
  hormone: "Endocrinology, Diabetes & Metabolism",

  // Rheumatology
  rheumatology: "Rheumatology",
  arthritis: "Rheumatology",
  joint: "Rheumatology",

  // Infectious Disease
  infectious: "Infectious Disease",
  infection: "Infectious Disease",
} as const;
